import { MODULE_NAME } from '@modules/gem-meter';
import type { Store } from 'vuex';
import type { RootState } from '@/store';
import { actions as AppActions } from '@/store/app/types';
import { gemMeterServices } from '../services';
import { MutationTypes } from './mutations';

export const ActionTypes = {
  UPDATE_ON_BOARDING: 'updateOnBoarding',
  UPDATE_LAST_USED: 'UPDATE_LAST_USED',
  GET_IMAGES: 'GET_IMAGES',
};

export const actions = {
  async [ActionTypes.UPDATE_ON_BOARDING](this: Store<RootState>, {}, payload: any) {
    this.state.app.shopMeter.onboarding = true;
    await this.dispatch(`app/${AppActions.UPDATE_SHOP_META_USE_KEY}`, {
      key: payload.key,
      metas: payload.metas,
    });
  },
  async [ActionTypes.UPDATE_LAST_USED](this: Store<RootState>, {}, lastUsedAt: string) {
    const result = await this.dispatch(`app/${AppActions.UPDATE_LAST_USED}`, lastUsedAt);

    return result;
  },

  async [ActionTypes.GET_IMAGES](this: Store<RootState>) {
    const result = await gemMeterServices.apiGetImages();
    this.commit(`${MODULE_NAME}/${MutationTypes.UPDATE_GEMPAGES_IMAGE}`, result?.data?.images || []);

    return result;
  },
};
